import React from 'react';
import { FaWhatsapp } from 'react-icons/fa';

const WhatsAppButton = () => {
  const phoneNumber = '27825777773';
  const whatsappUrl = `https://wa.me/${phoneNumber}`;

  return (
    <a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-button"
      className="fixed bottom-32 right-8 z-50 p-4 bg-[#25D366] hover:bg-[#20BA5A] rounded-full shadow-[0_4px_20px_rgba(37,211,102,0.6)] hover:shadow-[0_6px_30px_rgba(37,211,102,0.8)] transition-all duration-300 group"
      aria-label="Chat on WhatsApp"
    >
      <FaWhatsapp size={32} className="text-white" />
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 bg-[#25D366] text-white px-3 py-2 rounded whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-sm font-semibold">
        Chat with us
      </span>
    </a>
  );
};

export default WhatsAppButton;